const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  size: state => state.app.size,
  token: state => state.sys.token,
  name: state => state.sys.name,
  permission_routes: state => state.permission.routes,
  errorLogs: state => state.errorLog.logs,
  user: state => state.sys.user,
}
export default getters



// WEBPACK FOOTER //
// ./src/user/store/getters.js